import React from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation, Navigate} from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import ContactPage from "./pages/contact";
import DemanderUnDevis from "./pages/demanderUnDevis";
import About from "./pages/quiSommesNous";
import ScrollToTop from "./utils/ScrollToTop";
import Page from "./pages/page";
import {CookieConsent, Cookies} from "react-cookie-consent";
import SiteMap from "./pages/siteMap";
import Homepage from "./pages/homepage";
import Boursorama from "./pages/boursorama/home-7";
import GoogleAnalytics from "./GoogleAnalytics";
import Lahalle from "./pages/lahalle/home-7";
import Incluvia from "./pages/incluvia/home-7";

const PageTransition = ({ children }) => {
    return (
        <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ ease: 'easeInOut', duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
};

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
            <AnimatePresence mode="wait">
                <GoogleAnalytics />
                <ScrollToTop />
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<PageTransition><Homepage /></PageTransition>} />
                    <Route path="/boursorama" element={<PageTransition><Boursorama /></PageTransition>} />
                    <Route path="/lahalle" element={<PageTransition><Lahalle /></PageTransition>} />
                    <Route path="/incluvia" element={<PageTransition><Incluvia /></PageTransition>} />
                    <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
                    <Route path="/demander-un-devis" element={<PageTransition><DemanderUnDevis /></PageTransition>} />
                    <Route path="/qui-sommes-nous" element={<PageTransition><About /></PageTransition>} />
                    <Route path="/politique-confidentialite-donnees" element={<PageTransition><Page type={28} /></PageTransition>} />
                    <Route path="/mentions-legales" element={<PageTransition><Page type={29} /></PageTransition>} />
                    <Route path="/cgu" exact element={<PageTransition><Page type={27} /></PageTransition>} />
                    <Route path="/plan-site" exact element={<PageTransition><SiteMap /></PageTransition>} />
                    <Route path="/sessions" element={<Navigate to="/" replace />} />
                    <Route path="/nos-formations" element={<Navigate to="/" replace />} />
                    <Route path="/nos-formations/:formationId/:formationSlug" element={<Navigate to="/" replace />} />
                </Routes>
            </AnimatePresence>
    );
};
function App() {
    const handleAccept = () => {
        console.log('Cookies acceptés');
    };
    const handleDecline = () => {
        console.log('Cookies refusés');
        Cookies.remove('myAwesomeCookieName');
    };

   /* if (loading) {
        return <LoaderSpinner />;
    }*/

    return (
            <Router>
                <ScrollToTop />
                {/*<Suspense fallback={<LoaderSpinner />}>

                </Suspense>*/}
                <AnimatedRoutes />
                <CookieConsent
                        location="bottom"
                        buttonText="J'accepte"
                        declineButtonText="Je refuse"
                        cookieName="myAwesomeHotline"
                        style={{ background: "#2B373B" }}
                        buttonStyle={{ background: "#DEF2D7", color: "#5B7052", fontSize: "13px", borderRadius: "50px", padding: "6px 15px" }}
                        declineButtonStyle={{ background: "#ECC8C5", color: "#AB3331", borderRadius: "50px", padding: "6px 15px", fontSize: "13px"}}
                        expires={60}
                        onAccept={handleAccept}
                        onDecline={handleDecline}
                        enableDeclineButton
                        flipButtons={1}
                >
                    Ce site utilise des cookies pour améliorer l'expérience utilisateur.{" "}
                    <a href="/politique-confidentialite-donnees" style={{ color: "#ffffff" }}>En savoir plus</a>
                </CookieConsent>
            </Router>
    );
}

export default App;
